import React from 'react';
import { ExistingClinicFormProps } from '../../../../CreateClinic/types';
import ModifyClinicFooter from '../../ModifyClinicFooter';
import ModifyClinicConditionsBody from './ModifyClinicConditionsBody';
import styled from 'styled-components';

const ClinicConditionsTab = ({ form, clinic }: ExistingClinicFormProps) => {
  return (
    <>
      <h2>&nbsp;</h2>
      <PageHolder>
        <ModifyClinicConditionsBody clinicId={clinic._id} form={form} />
        <ModifyClinicFooter clinicId={clinic._id} form={form} />
      </PageHolder>
    </>
  );
};

const PageHolder = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  gap: 20px;
`;

export default ClinicConditionsTab;
